/* eslint-disable import/prefer-default-export */
import React, {
  Fragment, useEffect,
} from 'react';
import {
  Col, Row, Button, Divider, Typography,
  UserOutlined, roleService, useSwitchProfile, Popover, humps,
  useTranslation, camelCase, useNavigate,
  SearchOutlined,
} from '@lib/index';
import { Input } from 'antd';
import { ENV } from '@config/envConfig';
import { useFilteredRoles } from '@hooks/index';
import { RoleProps } from '../types';

export const SwitchProfile = () => {
  const { Text, Paragraph } = Typography;
  const { useGetRolesQuery } = roleService;
  const navigate = useNavigate();
  const { data, refetch } = useGetRolesQuery();
  const roles = humps(data) as RoleProps[];
  const { roleId } = useSwitchProfile();
  const handleSwitchRole = async (id: number) => navigate(`switching/${id}/switching`);
  const allowedRoles = (ENV.VITE_ALLOWED_ROLES || import.meta.env.VITE_ALLOWED_ROLES) as string;
  const { t } = useTranslation();
  const { searchText, setSearchText, filteredRoles } = useFilteredRoles({
    roles,
    allowedRoles,
  });

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userRoles = (
    <Row className="w-64 h-80 flex flex-col">
      <Input
        placeholder={t('roles.searchProfile')}
        value={searchText}
        name="name"
        onChange={(e) => setSearchText(e.target.value)}
        className="mb-2"
        allowClear
        suffix={<SearchOutlined />}
      />

      <Row className="overflow-y-auto flex-1 pr-1">
        {filteredRoles?.map((role) => (
          <Fragment key={role.id}>
            <Col span={12}>
              <Paragraph>
                <Text className="font-bold text-xs">{role.roleLabel}</Text>
                {' '}
                {t(`roles.${camelCase(role.category)}`)}
              </Paragraph>
            </Col>
            <Col span={12}>
              <Button
                shape="round"
                type={role.id === roleId ? 'primary' : 'default'}
                onClick={() => handleSwitchRole(role.id)}
                disabled={role.id === roleId}
              >
                {role.id === roleId ? t('login.active') : t('login.switch')}
              </Button>
            </Col>
            <Divider className="my-2" />
          </Fragment>
        ))}
      </Row>
    </Row>
  );

  return (
    <Popover placement="bottom" content={userRoles} trigger="click">
      <UserOutlined />
    </Popover>
  );
};
